import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'reverse',
  standalone: false,
})
export class ReversePipe implements PipeTransform {
  transform(value) {
    if (value) {
      var copy = value.slice(0);
      return copy.reverse();
    }
  }
}
